// proposalGeneralInfoModel.js

import { readNodeFieldRawValue } from 'utilities/NodeFieldData';

export const PROPOSAL_TYPE_KEY = 'PROPOSAL';
export const PROPOSAL_ITEM_TYPE_KEY = 'PROPOSAL_ITEM';

function normalizeString(value) {
  return String(value || '').trim();
}

export function resolveProposalTypeKey(node, nodeType = null) {
  return normalizeString(nodeType?.key || node?.type).toUpperCase() || PROPOSAL_TYPE_KEY;
}

export function readProposalField(node, fieldName, nodeType = null) {
  const typeKey = resolveProposalTypeKey(node, nodeType);
  return readNodeFieldRawValue(
    node,
    { name: fieldName, source: typeKey.toLowerCase() },
    typeKey,
  );
}
